import { baseApi } from "./baseApi";
import { buildPaginationQueryString } from "./queryHelpers";
import { HeadTeacherAdminDto, PaginateQuery } from "../../interfaces";

export const headTeacherAdminApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getHeadTeacherAdminUsers: builder.query<any, PaginateQuery>({
      query: (data) => ({
        url: buildPaginationQueryString(data, `/api/user/head-teacher-admin`),
      }),
      providesTags: ["Paginated-Head-Teacher-Admins"],
    }),
    getHeadTeacherAdminUser: builder.query<HeadTeacherAdminDto, string>({
      query: (id) => ({
        url: `/api/user/head-teacher-admin/${id}`,
      }),
      providesTags: ["HeadTeacherAdmin"],
    }),
    addHeadTeacherAdminUser: builder.mutation<any, any>({
      query: (data) => ({
        url: "/api/user/head-teacher-admin",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["Paginated-Head-Teacher-Admins"],
    }),
    updateHeadTeacherAdminUser: builder.mutation<
      any,
      { id: string; data: any }
    >({
      query: ({ id, data }) => ({
        url: `/api/user/head-teacher-admin/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: ["Paginated-Head-Teacher-Admins", "HeadTeacherAdmin"],
    }),
    deleteHeadTeacherAdminUser: builder.mutation<any, string>({
      query: (id) => ({
        url: `/api/user/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Paginated-Head-Teacher-Admins"],
    }),
  }),
});

export const {
  useGetHeadTeacherAdminUsersQuery,
  useGetHeadTeacherAdminUserQuery,
  useAddHeadTeacherAdminUserMutation,
  useUpdateHeadTeacherAdminUserMutation,
  useDeleteHeadTeacherAdminUserMutation,
} = headTeacherAdminApi;
